import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { mealPlanService } from './meal-plan.service'
import { showToast } from '@/shared/utils/toast'
import type { WeeklyMealPlan, UpdateServingMultiplierPayload } from './types'

export function useUpdateServingMultiplier(weekStartDate: string) {
  const queryClient = useQueryClient()
  const { t } = useTranslation('meal-plan')

  return useMutation({
    mutationFn: (payload: UpdateServingMultiplierPayload) => mealPlanService.updateServingMultiplier(payload),
    onMutate: async (payload) => {
      const queryKey = ['meal-plan', weekStartDate]
      await queryClient.cancelQueries({ queryKey })
      const prev = queryClient.getQueryData<WeeklyMealPlan>(queryKey)

      queryClient.setQueryData<WeeklyMealPlan>(queryKey, (old) => {
        if (!old) return old
        return {
          ...old,
          slots: old.slots.map((slot) =>
            slot.dayOfWeek === payload.dayOfWeek
              ? { ...slot, servingMultiplier: payload.servingMultiplier }
              : slot,
          ),
        }
      })

      return { prev }
    },
    onError: (_err, _payload, ctx) => {
      queryClient.setQueryData(['meal-plan', weekStartDate], ctx?.prev)
      showToast(t('error.updateServingFailed'))
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['meal-plan', weekStartDate] })
    },
  })
}
